module.exports = __webpack_public_path__ + "img/logo.0ba00549.png";